import * as React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

export interface IIccoMultiOfficeChecksParams {
    begPeriod: number;
    endPeriod: number;
    filename: string;
}

interface IIccoMultiOfficeChecksDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onGenerateReport: (params: IIccoMultiOfficeChecksParams) => void;
    message?: string;
    generating?: boolean;
}

const DEFAULT_FILENAME = 'Multi-Office-Checks.xlsx';

interface IIccoMultiOfficeChecksFormValues {
    begPeriod: string;
    endPeriod: string;
    filename: string;
}

// Mirrors the MO_EXCEL block/window "Mo_Excel" - Beg Period/End Period/Filename/OK/Cancel,
// styled the same as IccoExcelReportDialog (same Dialog/Button/RHFInputBox shapes) minus the
// Select Type/Office fields, which MO_EXCEL doesn't have.
const IccoMultiOfficeChecksDialog = (props: IIccoMultiOfficeChecksDialogProps) => {
    const { register, errors, getValues } = useForm<IIccoMultiOfficeChecksFormValues>({ defaultValues: { filename: DEFAULT_FILENAME } });

    const handleOk = () => {
        const values = getValues();
        props.onGenerateReport({
            begPeriod: Number(values.begPeriod),
            endPeriod: Number(values.endPeriod),
            filename: values.filename || DEFAULT_FILENAME,
        });
    };

    return (
        <Dialog title="ICCO Breakdown - Multi-Office Checks" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '32%' }}>
            <form>
                <RHFInputBox
                    label="Beg Period"
                    labelOnLeft={true}
                    labelStyle={{ whiteSpace: 'nowrap', width: '7rem' }}
                    name="begPeriod"
                    type="number"
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                />
                <div style={{ marginTop: '.75rem' }}>
                    <RHFInputBox
                        label="End Period"
                        labelOnLeft={true}
                        labelStyle={{ whiteSpace: 'nowrap', width: '7rem' }}
                        name="endPeriod"
                        type="number"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                </div>
                <div style={{ marginTop: '.75rem' }}>
                    <RHFInputBox
                        label="Filename"
                        labelOnLeft={true}
                        labelStyle={{ whiteSpace: 'nowrap', width: '7rem' }}
                        name="filename"
                        register={register}
                        errors={errors}
                        style={{ width: '100%' }}
                    />
                </div>
            </form>
            <div className="form-row" style={{ marginTop: '1.5rem', justifyContent: 'center' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '25%', marginRight: '1rem' }}
                    text={props.generating ? 'Generating...' : 'OK'}
                    disabled={props.generating}
                    loading={props.generating}
                    onClick={handleOk}
                />
                <Button className="blue-hover-button" style={{ width: '25%' }} text="Cancel" disabled={props.generating} onClick={() => props.hideDialog()} />
            </div>
            {!!props.message && (
                <div style={{ marginTop: '1rem', minHeight: '1.2rem', textAlign: 'center', color: 'red' }}>{props.message}</div>
            )}
        </Dialog>
    );
};

export default IccoMultiOfficeChecksDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/IccoMultiOfficeChecksDialog.tsx